import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getBranch } from '@src/api'
import {
  DefaultApiGetBranchRequest,
  GetBranch200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchBranch = (params: DefaultApiGetBranchRequest) => {
  const { axiosInstance } = useAxios()

  return useQuery<
    AxiosResponse<GetBranch200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: false,
    queryFn: () => getBranch(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_BRANCH, params],
  })
}
